  const generateSrcset = (image, widths = []) => {
    const imageUrl = new URL(image["src"]);
    return widths.filter((width) => width <= image["width"]).map((width) => {
      imageUrl.searchParams.set("width", width.toString());
      return `${imageUrl.href} ${width}w`;
    }).join(", ");
  }

  const createImageElement = (image, classes, sizes, productTitle) => {
    const previewImage = image["preview_image"];
    const newImage = new Image(previewImage["width"], previewImage["height"]);
    newImage.className = classes;
    newImage.alt = image["alt"] || productTitle;
    newImage.sizes = sizes;
    newImage.src = previewImage["src"];
    newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
    newImage.loading="lazy"
    return newImage;
  }

  const checkSwatches = () => {
    document.querySelectorAll('.js-color-swatches-wrapper').forEach(wrapper => {
      wrapper.querySelectorAll('.js-color-swatches input').forEach(input => {
        input.addEventListener('click', (event) => {
          const primaryImage = wrapper.querySelector(".media--first");
          const secondaryImage = wrapper.querySelector(".media--second");
          const handleProduct = wrapper.dataset.product;
          
          if (event.currentTarget.checked && primaryImage) {
            wrapper.querySelector('.js-color-swatches-link').setAttribute('href', event.currentTarget.dataset.variantLink);
            const currentColor = event.currentTarget.value;

            jQuery.getJSON(window.Shopify.routes.root + `products/${handleProduct}.js`, function(product) {
              const variant = product.variants.filter(item => item.featured_media != null && item.options.includes(currentColor))[0];
              if (variant) {
                const newPrimaryImage = createImageElement(variant["featured_media"], primaryImage.className, primaryImage.sizes, product.title);
                
                if (newPrimaryImage.src !== primaryImage.src) {
                  let flag = false;
                  if (secondaryImage) {
                    const secondaryImagePathname = new URL(secondaryImage.src).pathname;
                    const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

                    if (secondaryImagePathname == newPrimaryImagePathname) {
                      primaryImage.remove();
                      secondaryImage.classList.remove('media--second');
                      secondaryImage.classList.add('media--first');
                      flag = true;
                    } 
                  }
                  if (flag == false) {
                    primaryImage.animate({ opacity: [1, 0] }, { duration: 200, easing: "ease-in", fill: "forwards" }).finished;
                    setTimeout(function(){
                      primaryImage.replaceWith(newPrimaryImage);
                      newPrimaryImage.animate({ opacity: [0, 1] }, { duration: 200, easing: "ease-in" });
                      if (secondaryImage) {
                        secondaryImage.remove();                                    
                      }
                    }, 200);
                  }
                }
              }
            });
          }
        })
      })
    })
  }

  function colorSwatches() {
    checkSwatches();

    document.addEventListener('shopify:section:load', function () {
      checkSwatches();
    });
  }

(function () {
  colorSwatches();
})();

/* ==========================================================================
   Pages collection (F/W 27, Accessoires…) — swipe des photos produit
   Mobile uniquement (<= 989px). Le desktop n'est pas touché.
   Compatible « Charger plus » et filtres (nouvelles cartes détectées).
   ========================================================================== */
(function () {
  if (window.__pcsSwipe) return;
  window.__pcsSwipe = true;

  var MQ = window.matchMedia('(max-width: 989px)');
  var SECTION = '.collection-grid-section';
  var CARD = SECTION + ' li.collection-product-card';
  var MAX_IMAGES = 6;
  var cache = {};
  var io = null;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function handleOf(card) {
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }
  function fileKey(src) {
    return (src || '').split('?')[0].split('/').pop().replace(/_(\d+x\d*|\d*x\d+)(?=\.)/, '');
  }
  function sized(src, w) {
    var u = src.indexOf('//') === 0 ? 'https:' + src : src;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function fetchProduct(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch(root() + 'products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cache[handle];
  }

  function build(card) {
    if (card.dataset.pcsSwipe) return;
    var media = card.querySelector('.card__inner .media');
    var img = media && (media.querySelector('img.media--first') || media.querySelector('img'));
    var handle = handleOf(card);
    if (!media || !img || !handle) return;
    card.dataset.pcsSwipe = 'pending';

    fetchProduct(handle).then(function (p) {
      if (!p || !MQ.matches || !card.isConnected) { card.dataset.pcsSwipe = ''; return; }
      var list = (p.media && p.media.length)
        ? p.media.filter(function (m) { return m.media_type === 'image' && m.src; })
            .map(function (m) { return { src: m.src, alt: m.alt }; })
        : (p.images || []).map(function (s) { return { src: s, alt: '' }; });
      var firstKey = fileKey(img.currentSrc || img.src);
      var extras = list.filter(function (m) { return fileKey(m.src) !== firstKey; }).slice(0, MAX_IMAGES - 1);
      if (!extras.length) { card.dataset.pcsSwipe = 'single'; return; }

      var fit = getComputedStyle(img).objectFit || 'cover';
      var track = document.createElement('div');
      track.className = 'pcs-swipe';
      track.setAttribute('aria-label', (p.title || '') + ' — images');

      var marker = document.createComment('pcs-img');
      img.parentNode.insertBefore(marker, img);
      var s0 = document.createElement('div');
      s0.className = 'pcs-swipe__slide';
      s0.appendChild(img);
      track.appendChild(s0);

      extras.forEach(function (m, i) {
        var s = document.createElement('div');
        s.className = 'pcs-swipe__slide';
        var im = document.createElement('img');
        im.alt = m.alt || p.title || '';
        im.decoding = 'async';
        if (i > 0) im.loading = 'lazy';
        im.sizes = img.getAttribute('sizes') || '(max-width: 749px) 50vw, 33vw';
        im.srcset = [360, 540, 720, 900].map(function (w) { return sized(m.src, w) + ' ' + w + 'w'; }).join(', ');
        im.src = sized(m.src, 540);
        im.style.objectFit = fit;
        s.appendChild(im);
        track.appendChild(s);
      });

      var dots = document.createElement('div');
      dots.className = 'pcs-dots';
      dots.setAttribute('aria-hidden', 'true');
      for (var d = 0; d < extras.length + 1; d++) {
        var dot = document.createElement('i');
        if (d === 0) dot.className = 'is-active';
        dots.appendChild(dot);
      }
      media.appendChild(track);
      media.appendChild(dots);

      var current = 0;
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var idx = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
          if (idx !== current && dots.children[idx]) {
            dots.children[current].classList.remove('is-active');
            dots.children[idx].classList.add('is-active');
            current = idx;
          }
        });
      }, { passive: true });

      // Tap simple sur la photo : ouvre la fiche produit comme avant
      track.addEventListener('click', function () {
        var link = card.querySelector('.link--overlay') || card.querySelector('.card__title a');
        if (link) link.click();
      });
      // Changement de couleur : retour sur la photo principale
      card.addEventListener('change', function (e) {
        if (e.target && e.target.type === 'radio') track.scrollTo({ left: 0, behavior: 'auto' });
      });

      card._pcsTeardown = function () {
        var first = s0.querySelector('img');
        if (first && marker.parentNode) marker.parentNode.insertBefore(first, marker);
        marker.remove();
        track.remove();
        dots.remove();
        card.dataset.pcsSwipe = '';
        card._pcsTeardown = null;
      };
      card.dataset.pcsSwipe = 'ready';
    });
  }

  function observe() {
    if (!MQ.matches) return;
    var cards = document.querySelectorAll(CARD);
    if (!cards.length) return;
    if (!('IntersectionObserver' in window)) { cards.forEach(build); return; }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { io.unobserve(en.target); build(en.target); }
        });
      }, { rootMargin: '300px 0px' });
    }
    cards.forEach(function (c) {
      if (!c.dataset.pcsSwipe && !c.dataset.pcsObserved) { c.dataset.pcsObserved = '1'; io.observe(c); }
    });
  }
  function teardownAll() {
    if (io) { io.disconnect(); io = null; }
    document.querySelectorAll(CARD).forEach(function (c) {
      if (c._pcsTeardown) c._pcsTeardown();
      c.dataset.pcsObserved = '';
      if (c.dataset.pcsSwipe !== 'pending') c.dataset.pcsSwipe = '';
    });
  }

  // Nouvelles cartes (Charger plus, filtres, éditeur de thème)
  var pending = null;
  function schedule() {
    clearTimeout(pending);
    pending = setTimeout(observe, 120);
  }
  function start() {
    observe();
    if ('MutationObserver' in window) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].addedNodes.length) { schedule(); return; }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  // Glisser à la souris / trackpad (aperçu mobile de l'éditeur, petites fenêtres)
  var drag = null;
  function trackOf(e) {
    return e.target && e.target.closest ? e.target.closest(SECTION + ' .pcs-swipe') : null;
  }
  document.addEventListener('dragstart', function (e) { if (trackOf(e)) e.preventDefault(); });
  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    var t = trackOf(e);
    if (t) drag = { track: t, x: e.clientX, left: t.scrollLeft, moved: false };
  });
  document.addEventListener('pointermove', function (e) {
    if (!drag) return;
    var dx = e.clientX - drag.x;
    if (!drag.moved && Math.abs(dx) > 5) {
      drag.moved = true;
      drag.track.style.scrollSnapType = 'none';
      drag.track.style.scrollBehavior = 'auto';
    }
    if (drag.moved) { e.preventDefault(); drag.track.scrollLeft = drag.left - dx; }
  });
  function endDrag(e) {
    if (!drag) return;
    var d = drag;
    drag = null;
    if (!d.moved) return;
    var t = d.track;
    var w = Math.max(t.clientWidth, 1);
    var dx = (e.clientX || d.x) - d.x;
    var start = Math.round(d.left / w);
    var idx = Math.abs(dx) > w * 0.15 ? start + (dx < 0 ? 1 : -1) : start;
    idx = Math.max(0, Math.min(idx, t.children.length - 1));
    t.style.scrollBehavior = '';
    t.scrollTo({ left: idx * w, behavior: 'smooth' });
    setTimeout(function () { t.style.scrollSnapType = ''; }, 450);
    var block = function (ev) { ev.stopImmediatePropagation(); ev.preventDefault(); };
    t.addEventListener('click', block, true);
    setTimeout(function () { t.removeEventListener('click', block, true); }, 60);
  }
  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);

  function onMQ() { if (MQ.matches) observe(); else teardownAll(); }
  if (MQ.addEventListener) MQ.addEventListener('change', onMQ); else MQ.addListener(onMQ);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();


/* ==========================================================================
   Pages collection — « + » Vue rapide à droite du nom du produit.
   Le bouton Vue rapide existant est déplacé tel quel : la Quick View
   s'ouvre exactement comme avant. Compatible « Charger plus » et filtres.
   ========================================================================== */
(function () {
  if (window.__pcsPlus) return;
  window.__pcsPlus = true;

  var CARD = '.collection-grid-section li.collection-product-card, .popular-products-section li.collection-product-card';

  function place(card) {
    if (card.dataset.pcsPlus) return;
    var opener = card.querySelector('.quick-add modal-opener');
    var title = card.querySelector('.card__title');
    if (!opener || !title) return;
    var holder = document.createElement('span');
    holder.className = 'pcs-plus';
    holder.appendChild(opener);
    title.appendChild(holder);
    card.classList.add('has-pcs-plus');
    card.dataset.pcsPlus = '1';
  }
  function run() {
    document.querySelectorAll(CARD).forEach(place);
  }

  var pending = null;
  function start() {
    run();
    if ('MutationObserver' in window) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].addedNodes.length) {
            clearTimeout(pending);
            pending = setTimeout(run, 60);
            return;
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* ==========================================================================
   POLMA — Navigation photos desktop (flèches au survol)
   Cartes produits : pages collections + section « Dernière release ».
   Desktop uniquement (>= 990px, souris). Le swipe mobile n'est pas touché.
   ========================================================================== */
;(function () {
  if (window.__pcdArrows) return;
  window.__pcdArrows = true;

  var MQ = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  var CARD = '.collection-grid-section li.collection-product-card, .popular-products-section li.collection-product-card';
  var MAX_IMAGES = 6;
  var cache = {};
  var io = null;

  var CSS = [
    '@media (min-width: 990px) and (hover: hover) and (pointer: fine) {',
    '  .pcd-on .card__inner .media.media--hover-effect > img:first-child { opacity: 1 !important; }',
    '  .pcd-on .card__inner .media.media--hover-effect > img + img { opacity: 0 !important; }',
    '  .pcd-stage { position: absolute; inset: 0; z-index: 1; pointer-events: none; }',
    '  .card .media > .pcd-stage > img { position: absolute; top: 0; left: 0; width: 100%; height: 100%; max-width: none; opacity: 0;',
    '    transition: opacity .5s cubic-bezier(.22,.61,.36,1), transform var(--duration-long, .5s) ease; }',
    '  .card .media > .pcd-stage > img.is-active { opacity: 1; }',
    '  .collection-product-card.quickview--hover:hover .pcd-stage > img { transform: scale(1.12); }',
    '  .pcd-nav { position: absolute; top: 50%; z-index: 3; width: 34px; height: 34px; margin-top: -17px; padding: 0;',
    '    display: flex; align-items: center; justify-content: center; border: 0; border-radius: 50%; cursor: pointer;',
    '    color: #1f1f1f; background: rgba(255,255,255,.62); -webkit-backdrop-filter: blur(6px); backdrop-filter: blur(6px);',
    '    opacity: 0; pointer-events: none; transition: opacity .3s ease, transform .3s ease, background-color .2s ease; }',
    '  .pcd-nav--prev { left: 12px; transform: translateX(-4px); }',
    '  .pcd-nav--next { right: 12px; transform: translateX(4px); }',
    '  .pcd-nav svg { width: 12px; height: 12px; display: block; }',
    '  .pcd-on:hover .pcd-nav { opacity: 1; pointer-events: auto; transform: none; }',
    '  .pcd-nav:hover { background: rgba(255,255,255,.92); }',
    '  .pcd-nav:focus, .pcd-nav:focus-visible, .pcd-nav:active { outline: none; box-shadow: none; }',
    '}',
    '@media (prefers-reduced-motion: reduce) { .pcd-stage > img, .pcd-nav { transition: none !important; } }'
  ].join('\n');

  var ICON_PREV = '<svg viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M7.5 2 3.5 6l4 4" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICON_NEXT = '<svg viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="m4.5 2 4 4-4 4" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function injectCSS() {
    if (document.getElementById('pcd-arrows-css')) return;
    var st = document.createElement('style');
    st.id = 'pcd-arrows-css';
    st.textContent = CSS;
    document.head.appendChild(st);
  }

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function handleOf(card) {
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }
  function fileKey(src) {
    return (src || '').split('?')[0].split('/').pop().replace(/_(\d+x\d*|\d*x\d+)(?=\.)/, '');
  }
  function sized(src, w) {
    var u = src.indexOf('//') === 0 ? 'https:' + src : src;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function fetchProduct(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch(root() + 'products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cache[handle];
  }

  function makeBtn(dir, label, icon) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'pcd-nav pcd-nav--' + dir;
    b.setAttribute('aria-label', label);
    b.tabIndex = -1; // jamais de focus : visibilité 100 % liée au survol
    b.addEventListener('mousedown', function (e) { e.preventDefault(); });
    b.innerHTML = icon;
    return b;
  }

  function build(card) {
    if (card.dataset.pcd) return;
    var inner = card.querySelector('.card__inner');
    var media = inner && inner.querySelector('.media');
    var img = media && (media.querySelector('img.media--first') || media.querySelector('img'));
    var handle = handleOf(card);
    if (!inner || !media || !img || !handle) return;
    card.dataset.pcd = 'pending';

    fetchProduct(handle).then(function (p) {
      if (!p || !MQ.matches || !card.isConnected) { card.dataset.pcd = ''; return; }
      var list = (p.media && p.media.length)
        ? p.media.filter(function (m) { return m.media_type === 'image' && m.src; }).map(function (m) { return { src: m.src, alt: m.alt }; })
        : (p.images || []).map(function (s) { return { src: s, alt: '' }; });
      var firstKey = fileKey(img.currentSrc || img.src);
      var extras = list.filter(function (m) { return fileKey(m.src) !== firstKey; }).slice(0, MAX_IMAGES - 1);
      if (!extras.length) { card.dataset.pcd = 'single'; return; }

      var fit = getComputedStyle(img).objectFit || 'cover';
      var sizes = img.getAttribute('sizes') || '(min-width: 990px) 25vw, 50vw';
      var stage = document.createElement('div');
      stage.className = 'pcd-stage';
      stage.setAttribute('aria-hidden', 'true');
      var slides = extras.map(function (m) {
        var im = document.createElement('img');
        im.alt = m.alt || p.title || '';
        im.decoding = 'async';
        im.style.objectFit = fit;
        im.dataset.src = m.src;
        im.setAttribute('sizes', sizes);
        stage.appendChild(im);
        return im;
      });
      media.appendChild(stage);

      var prev = makeBtn('prev', 'Photo précédente', ICON_PREV);
      var next = makeBtn('next', 'Photo suivante', ICON_NEXT);
      inner.appendChild(prev);
      inner.appendChild(next);

      var total = extras.length + 1; // index 0 = image d'origine de la carte
      var index = 0;

      function load(im) {
        if (!im || im.src) return;
        var s = im.dataset.src;
        im.srcset = [360, 533, 720, 940, 1066].map(function (w) { return sized(s, w) + ' ' + w + 'w'; }).join(', ');
        im.src = sized(s, 720);
      }
      function warm() {
        load(slides[0]);
        load(slides[slides.length - 1]);
      }
      function go(i) {
        index = (i + total) % total;
        slides.forEach(function (im, k) { im.classList.toggle('is-active', k === index - 1); });
        if (index > 0) load(slides[index - 1]);
        load(slides[index % slides.length]);
        load(slides[(index - 2 + slides.length) % slides.length]);
      }
      function onNav(step) {
        return function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (e.currentTarget && e.currentTarget.blur) e.currentTarget.blur();
          go(index + step);
        };
      }

      prev.addEventListener('click', onNav(-1));
      next.addEventListener('click', onNav(1));
      card.addEventListener('mouseenter', warm);
      // Changement de couleur (swatch) : retour sur l'image d'origine
      var onChange = function (e) { if (e.target && e.target.type === 'radio') go(0); };
      card.addEventListener('change', onChange);

      card._pcdTeardown = function () {
        card.removeEventListener('mouseenter', warm);
        card.removeEventListener('change', onChange);
        stage.remove(); prev.remove(); next.remove();
        card.classList.remove('pcd-on');
        card.dataset.pcd = '';
        card._pcdTeardown = null;
      };
      card.classList.add('pcd-on');
      card.dataset.pcd = 'ready';
    });
  }

  function observe() {
    if (!MQ.matches) return;
    injectCSS();
    var cards = document.querySelectorAll(CARD);
    if (!cards.length) return;
    if (!('IntersectionObserver' in window)) { cards.forEach(build); return; }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { io.unobserve(en.target); build(en.target); }
        });
      }, { rootMargin: '300px 0px' });
    }
    cards.forEach(function (c) {
      if (!c.dataset.pcd && !c.dataset.pcdObserved) { c.dataset.pcdObserved = '1'; io.observe(c); }
    });
  }

  function teardownAll() {
    if (io) { io.disconnect(); io = null; }
    document.querySelectorAll(CARD).forEach(function (c) {
      if (c._pcdTeardown) c._pcdTeardown();
      c.dataset.pcdObserved = '';
      if (c.dataset.pcd !== 'pending') c.dataset.pcd = '';
    });
  }

  var pending = null;
  function schedule() { clearTimeout(pending); pending = setTimeout(observe, 120); }

  function start() {
    observe();
    if ('MutationObserver' in window) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].addedNodes && muts[i].addedNodes.length) { schedule(); return; }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  function onMQ() { MQ.matches ? observe() : teardownAll(); }
  if (MQ.addEventListener) MQ.addEventListener('change', onMQ); else MQ.addListener(onMQ);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
